// extracted by mini-css-extract-plugin
export default {"RestaurantsList__RestaurantSelector":"RestaurantsList_RestaurantsList__RestaurantSelector__3kRdv"};